export default "/images/b3500229e4317e56f0431afee2c3c301.avif";